import React, { useState, useEffect, useRef } from 'react';
import { Redirect, Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
import 'react-accessible-accordion/dist/fancy-example.css';

import { getTokenInfo } from './../../../UseToken';
import { reqGET } from '../../../Utils';
import { language } from './Language';
import Loader from '../../Loader/Loader';
import Hosts from "../../../Hosts"
import { color } from "../Color"
import { api_crud_route, data_interface, endpoints } from './Config';

export default function View(props) {

    const [dados, set_dados] = useState(data_interface);
    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);
    const [lang, set_lang] = useState('pt');
    const [next, setNext] = useState({});
    const [prev, setPrev] = useState({});
    const sanitizedContent = DOMPurify.sanitize(dados.content[0].text);

    const fetchInfo = async (id) => {
        try {

            const res = await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`);
            set_dados(res.data[0]);

            // Obter próxima e anterior notícias publicadas
            const res_next = await reqGET(`${Hosts.SIMCore_API}/web/content/type/${getTokenInfo().companycode}/news/published/${id}/next`);
            const res_prev = await reqGET(`${Hosts.SIMCore_API}/web/content/type/${getTokenInfo().companycode}/news/published/${id}/prev`);

            setNext(res_next.data);
            setPrev(res_prev.data);

        } catch (error) {
            console.error("Erro ao buscar informações:", error);


        }
    };

    const change_lang = (l) => {
        set_lang(l)
        window.location.reload()

        //console.log('language', localStorage.getItem('lang'))
        //console.log('localstorage', localStorage)
    }

    useEffect(() => {
        //set_lang('pt')
        //set_lang_id('1')

        //get_fact_legacy_info()
        //get_fact_legacy_info()

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            change_lang('pt')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            console.log("estamos a alterar para", lang)
        }

        setLoading(false)

    }, [props])

    useEffect(() => {

        if (props.location.state !== undefined) {

            fetchInfo(props.location.state.item['id']).then(() => setLoading(false))
        }
        else {
            setLoading(false);
            setRedirect(true);
        }

    }, [props]);

    /* Notícias */
    console.log('Notícias', dados)

    return isRedirect ?
        <Redirect to={endpoints.list} replace />
        :
        isloading ?

            <Loader />

            :

            <div id="kt_content" className="content d-flex flex-column flex-column-fluid">
                <div
                    id="printable"
                    className="d-flex flex-column align-items-center p-5"
                    style={{
                        fontFamily: '"Helvetica Neue", Arial, sans-serif',
                        backgroundColor: color.cor3.hexa,
                    }}
                >
                    <div className="w-75 bg-white rounded shadow-sm p-3">
                        <div className="row-md-1">
                            <section>
                                <p className="text-end fst-italic mb-1">{language[lang].aaa}</p>
                            </section>
                        </div>

                        <div className="row-md-1">
                            <section className="mt-3 pt-2 border-top">
                                <h1 className="text-center mt-4 mb-2 h3">
                                    {dados.content[0].title}
                                </h1>
                            </section>
                        </div>

                        <div className="row-md-1" style={{ marginTop: '5%' }}>
                            <section className="my-3">
                                <h2 className="h3 fw-bold">{language[lang].resume}</h2>
                                <p className="fs-6" style={{ fontFamily: '"Helvetica Neue", Arial, sans-serif' }}>
                                    {dados.content[0].abstract}
                                </p>
                            </section>
                        </div>

                        <div className="row-md-1" style={{ marginTop: '5%' }}>
                            <section className="my-3">
                                <h2 className="h3 fw-bold">{language[lang].content_view}</h2>
                                <div
                                    className="fs-6"
                                    style={{
                                        lineHeight: '2.0',
                                        wordWrap: 'break-word',
                                        fontFamily: '"Helvetica Neue", Arial, sans-serif',
                                    }}
                                    dangerouslySetInnerHTML={{ __html: sanitizedContent }}
                                />
                            </section>
                        </div>

                        <div className="row d-flex justify-content-start">
                            {dados?.content?.[0]?.media?.image?.length > 0 && (                                
                                    <div className="row">
                                        {dados.content[0]?.media?.image?.map((img, index) => (
                                            <div key={index} className="col-md-6 d-flex justify-content-center mb-3">
                                                <img
                                                    src={img?.link}
                                                    alt={`Image ${index + 1}`}
                                                    style={{ width: "100%", height: "auto" }}
                                                />
                                            </div>
                                        ))}
                                    </div>                                
                            )}
                        </div>

                        <div className="row d-flex align-items-start">
                            <div className="col-md-8">
                                <section className="my-3">
                                    <p className="fs-12">
                                        <strong>{language[lang].date_creation}: </strong>
                                        {new Date(dados.info.date.creation).toLocaleString()}
                                    </p>
                                </section>

                                <section className="my-3">
                                    <p className="fs-12">
                                        <strong>{language[lang].table_date_published}: </strong>
                                        {new Date(dados.info.date.published).toLocaleDateString()}
                                    </p>
                                </section>

                                <section className="my-3">
                                    <p className="fs-12">
                                        <strong>{language[lang].avaiable}: </strong>
                                        {new Date(dados.info.date.avaiable).toLocaleString()}
                                    </p>
                                </section>

                                {dados.info.date.modified && dados.info.date.modified.length > 0 && (
                                    <section className="my-3">
                                        <p className="fs-12">
                                            <strong>{language[lang].last_mod}: </strong>
                                            {new Date(Math.max(...dados.info.date.modified.map((date) => new Date(date)))).toLocaleString()}
                                        </p>
                                    </section>
                                )}
                            </div>
                        </div>

                        <section className="my-3 d-flex justify-content-between align-items-center mt-5">
                            <p className="fst-italic fs-6">
                                {dados.info.source.profile}: {dados.info.source.name}
                            </p>
                            <p className="text-end fst-italic fs-6">
                                {language[lang].source_text}: {dados.info.source.text}
                            </p>
                        </section>

                    </div>
                </div>
                <div className={'dash-cards footer'}>
                    <nav className="navbar bottom-navbar navbar-light">
                        <div className="navbar-footer">
                            <ul className="navbar-nav float-left"></ul>
                            <ul className="navbar-nav float-right">

                                <li className={"nav-item " + getTokenInfo().profile}>
                                    <a className="nav-link btn-cancel" href={Hosts.WEB_BACKOFFICE_URI}>
                                        <i className="bi bi-arrow-left"></i>
                                        <span> {language[lang].back}</span>
                                    </a>
                                </li>

                                {Object.keys(prev).length > 0 && (
                                    <li className={"nav-item " + getTokenInfo().profile}>
                                        <Link
                                            className="nav-link"
                                            to={{ pathname: endpoints.view, state: { item: prev, operation: 'view' } }}
                                            replace
                                        >
                                            <i className="bi bi-arrow-left"></i>
                                            <span> {language[lang].previous}</span>
                                        </Link>
                                    </li>
                                )}

                                {(getTokenInfo().profile === 'Administrador' || getTokenInfo().profile === 'TeamLeader') && (
                                    <li className={"nav-item " + getTokenInfo().profile}>
                                        <Link
                                            className="nav-link"
                                            to={{ pathname: endpoints.regist, state: { item: dados, operation: 'edit' } }}
                                            replace
                                        >
                                            <i className="bi bi-pencil-square"></i>
                                            <span> {language[lang].edit}</span>
                                        </Link>
                                    </li>
                                )}

                                {Object.keys(next).length > 0 && (
                                    <li className={"nav-item " + getTokenInfo().profile}>
                                        <Link
                                            className="nav-link"
                                            to={{ pathname: endpoints.view, state: { item: next, operation: 'view' } }}
                                            replace
                                        >
                                            <i className="bi bi-arrow-right"></i>
                                            <span> {language[lang].next}</span>
                                        </Link>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>

}